import React, { useEffect, useState } from 'react';
import { Layout, SiteNav, Modal, Input } from '@vwfs-bronson/bronson-react';
import { t } from 'i18next';
import { useSelector } from 'react-redux';
import { CompanyListItemForNavDropdown } from './CompanyListItemForNavDropdown';
import { mockOutletList } from '../../screens/OutletPage/OutletPage';
import { CompanyListItemForModal } from './CompanyListItemForModal';
import { getSelectedOutlet } from '../../services/redux/features/outlet.slice';
import { sortObjectsArray } from '../../services/common/miscUtils';
import { getOutletDisplayText } from './utils';

type Props = {
  headerItemClassName?: string;
};

const getInitialSortedCompanies = (
  companies: DealerIntegration.Components.Schemas.MilesBrokerCompaniesData[],
  selectedMilesCompanyId?: string
) => {
  return sortObjectsArray(companies, (company) => (company.milesBerCode === selectedMilesCompanyId ? 0 : 1));
};

export const SelectableCompanyListWithModal: React.FC<Props> = ({ headerItemClassName }) => {
  const isModalMode = mockOutletList.length > 5;
  const [showModal, setShowModal] = useState<boolean>(false);
  const [searchText, setSearchText] = useState<string>('');
  const selectedOutlet = useSelector(getSelectedOutlet);
  const [sortedCompanies, setSortedCompanies] = useState(() =>
    getInitialSortedCompanies(mockOutletList, selectedOutlet?.milesCompanyId)
  );

  useEffect(() => {
    setSortedCompanies(getInitialSortedCompanies(mockOutletList, selectedOutlet?.milesCompanyId));
    setShowModal(false);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedOutlet]);

  const handleClick = () => {
    if (isModalMode) {
      setSearchText('');
      setSortedCompanies(getInitialSortedCompanies(mockOutletList, selectedOutlet?.milesCompanyId));
      setShowModal(true);
    }
  };

  return (
    <>
      <SiteNav.Item icon label={t('dashboard:header:dealerCode')} className={headerItemClassName} onClick={handleClick}>
        {!isModalMode &&
          sortedCompanies.map((company: DealerIntegration.Components.Schemas.MilesBrokerCompaniesData) => (
            <CompanyListItemForNavDropdown key={company.milesBerCode} company={company} />
          ))}
      </SiteNav.Item>

      {showModal && (
        <Modal
          style={{ overflow: 'hidden' }}
          title={t('dashboard:header:dealerCode')}
          onClose={() => setShowModal(false)}
          asPortal
          shown
        >
          <div style={{ position: 'sticky', top: 0 }}>
            <Layout middle className="u-p-xsmall u-bg-pale">
              <Layout.Item>
                <Input
                  placeholder={t('dashboard:header:searchText')}
                  value={searchText}
                  onChange={(event) => {
                    const text = event.target.value;
                    setSearchText(text);

                    if (text.length === 0) {
                      setSortedCompanies(getInitialSortedCompanies(mockOutletList, selectedOutlet?.milesCompanyId));
                    } else {
                      setSortedCompanies(
                        sortObjectsArray(mockOutletList, (company) =>
                          getOutletDisplayText(company).toLowerCase().includes(text.toLowerCase()) ? 0 : 1
                        )
                      );
                    }
                  }}
                />
              </Layout.Item>
            </Layout>
          </div>

          {sortedCompanies.map((company: DealerIntegration.Components.Schemas.MilesBrokerCompaniesData) => (
            <CompanyListItemForModal key={company.milesBerCode} company={company} searchText={searchText} />
          ))}
        </Modal>
      )}
    </>
  );
};
